const SYSTEM_SETTINGS = {
  SYSTEM_SETTINGS: 'System settings',
  REQUEST_MARKET_INDICATORS: 'Request market indicators',
  INDICATORS_TYPE: 'Type',
  INDICATOR_REQUESTS_HEDGING: 'Outstanding hedging indicator requests',
  INDICATOR_REQUESTS_SETTLEMENT: 'Outstanding settlement indicator requests',
};

export { SYSTEM_SETTINGS };
